import { type RefObject, useEffect } from 'react';

import { useSearchActions } from '../../controllers/store/search';
import {
	type ExternalInputAnalyticsHandle,
	useExternalInputAnalytics,
} from './external-input-analytics';
import { useQueryFilters } from './textfield/query-filters';

type ExternalInputQuerySyncProps = {
	localQuery: string;
	postQueryDisabled?: boolean;
	analyticsRef?: RefObject<ExternalInputAnalyticsHandle | null>;
};

/**
 * Keeps the Quick Find store in step with a host-owned input. `SearchTextField` normally does this
 * as a side effect of rendering; in external-input mode it is not rendered, so the same hooks run
 * here instead.
 */
export const ExternalInputQuerySync = ({
	localQuery,
	postQueryDisabled,
	analyticsRef,
}: ExternalInputQuerySyncProps): null => {
	const { setQueryUpdatedTime } = useSearchActions();

	useQueryFilters(localQuery, postQueryDisabled);
	useExternalInputAnalytics(analyticsRef);

	useEffect(() => {
		setQueryUpdatedTime();
	}, [setQueryUpdatedTime, localQuery]);

	return null;
};
